module.exports = __webpack_public_path__ + "static/media/F7.e6fec26f.mp3";